/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from "react";
import { Row, Col, Menu, Dropdown, Button, message, Card } from "antd";
import { Link } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { ChartCard } from "../../../components/widget";
import Layout from "../../../layouts/MocoLayout";
import oRest from "../../../apis/rest";
import config from "./index.config";
import useWindowDimensions from "../../../helper/viewport";
import "./index.scss";

const API_URL = "webhook/dataquery/?qname=";

const menuCardStyle = {
  padding: 12,
  borderRadius: 16,
  color: "#fff",
  backgroundColor: "#1B6FBA",
  margin: "0px 12px 12px 0px",
  textAlign: "center",
};

const Page = () => {
  const [cards, setCards] = useState(config.cards);
  const [selectedAgama, setAgama] = useState("");
  const [selectedProvince, setProvince] = useState("");
  const [provinceMenu, setProvinceMenu] = useState([]);
  const agama = ["Khonghucu", "Hindu", "Buddha", "Kristen", "Katolik"];

  const { width } = useWindowDimensions();

  const toPascalCase = (params) => {
    return params.charAt(0).toUpperCase() + params.slice(1).toLowerCase();
  };

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}survey5agama_list_provinsi`;
      oRest
        .get(api)
        .then(({ data }) => {
          setProvinceMenu(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.tendikGender.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      const chartData = [
        { value: 0, name: "Laki-laki" },
        { value: 0, name: "Perempuan" },
      ];
      oRest
        .get(api)
        .then(({ data }) => {
          chartData[0].value =
            data[0].laki.substring(1, data[0].laki.length - 1) || 0;
          chartData[1].value =
            data[0].perempuan.substring(1, data[0].perempuan.length - 1) || 0;
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              tendikGender: {
                ...card.chart.tendikGender,
                options: {
                  ...card.chart.tendikGender.options,
                  chartOption: {
                    ...card.chart.tendikGender.options.chartOption,
                    series: [
                      {
                        ...card.chart.tendikGender.options.chartOption
                          .series[0],
                        data: chartData,
                      },
                    ],
                  },
                  dataSource: chartData.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data: chartData,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.profilLulusan.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data.forEach((itemData) => {
            itemData.laki2 = itemData.laki2 ?? 0;
            itemData.perempuan = itemData.perempuan ?? 0;
          });
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              profilLulusan: {
                ...card.chart.profilLulusan,
                options: {
                  ...card.chart.profilLulusan.options,
                  chartOption: {
                    ...card.chart.profilLulusan.options.chartOption,
                    xAxis: {
                      ...card.chart.profilLulusan.options.chartOption.xAxis,
                      data: data.map((e) => e.tahun),
                    },
                    series: [
                      {
                        ...card.chart.profilLulusan.options.chartOption
                          .series[0],
                        data: data.map((e) => e.laki2),
                      },
                      {
                        ...card.chart.profilLulusan.options.chartOption
                          .series[1],
                        data: data.map((e) => e.perempuan),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.tendikLulusan.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data.forEach((itemData) => {
            itemData.laki2 = itemData.laki2 ?? 0;
            itemData.perempuan = itemData.perempuan ?? 0;
          });
          data = data.sort((a, b) => a.laki2 - b.laki2);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              tendikLulusan: {
                ...card.chart.tendikLulusan,
                options: {
                  ...card.chart.tendikLulusan.options,
                  chartOption: {
                    ...card.chart.tendikLulusan.options.chartOption,
                    yAxis: {
                      ...card.chart.tendikLulusan.options.chartOption.yAxis,
                      data: data.map((e) => e.pendidikan),
                    },
                    series: [
                      {
                        ...card.chart.tendikLulusan.options.chartOption
                          .series[0],
                        data: data.map((e) => e.laki2),
                      },
                      {
                        ...card.chart.tendikLulusan.options.chartOption
                          .series[1],
                        data: data.map((e) => e.perempuan),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  const handleFilterAgama = (value) => {
    setAgama(value.key === "all" ? "" : value.key);
  };

  const handleFilterProvinsi = (value) => {
    setProvince(value.key === "all" ? "" : value.key);
  };

  const agamaMenu = (
    <Menu onClick={handleFilterAgama}>
      <Menu.Item key="all">Semua Agama</Menu.Item>
      {agama.map((e) => {
        return <Menu.Item key={e}>{e}</Menu.Item>;
      })}
    </Menu>
  );

  const provinceDropdownMenu = (
    <Menu onClick={handleFilterProvinsi}>
      <Menu.Item key="all">Nasional</Menu.Item>
      {provinceMenu
        ?.map((e) => e.lembaga_provinsi)
        .sort((a, b) =>
          // eslint-disable-next-line no-nested-ternary
          a > b ? 1 : b > a ? -1 : 0
        )
        .map((e) => {
          return <Menu.Item key={e}>{toPascalCase(e)}</Menu.Item>;
        })}
    </Menu>
  );

  return (
    <Layout>
      <div
        style={{
          display: "flex",
          flexFlow: "row",
          flexWrap: "wrap",
          justifyContent: width > 795 ? "space-between" : "center",
        }}
      >
        <div>
          <Row justify={width > 795 ? "start" : "center"}>
            <Link to="/pendidikan-keagamaan/1" key="overview">
              <Col style={menuCardStyle}>
                <span className="text-default">Overview</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/2" key="lembaga">
              <Col style={menuCardStyle}>
                <span className="text-default">Lembaga</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/3" key="sdm">
              <Col style={menuCardStyle}>
                <span className="text-default">SDM</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/4" key="sarana">
              <Col style={menuCardStyle}>
                <span className="text-default">Sarana</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/5" key="pendidikan">
              <Col style={menuCardStyle}>
                <span className="text-default">Pendidikan</span>
              </Col>
            </Link>
          </Row>
        </div>
        <div>
          <Row justify={width > 795 ? "start" : "center"}>
            <Col>
              <Dropdown overlay={agamaMenu}>
                <Button
                  size="large"
                  shape="round"
                  style={{
                    backgroundColor: "#1B6FBA",
                    color: "#fff",
                  }}
                >
                  Pilih agama &nbsp;
                  <DownOutlined />
                </Button>
              </Dropdown>
            </Col>
            <Col>
              <Dropdown
                overlay={provinceDropdownMenu}
                overlayStyle={{ height: 300, overflowY: "auto" }}
              >
                <Button
                  size="large"
                  shape="round"
                  style={{
                    backgroundColor: "#1B6FBA",
                    color: "#fff",
                  }}
                >
                  Pilih provinsi &nbsp;
                  <DownOutlined />
                </Button>
              </Dropdown>
            </Col>
          </Row>
        </div>
      </div>
      <Row gutter={[24, 24]} style={{ paddingTop: "8px" }} id="DataSDM">
        <Col span={24}>
          <Card
            style={{
              borderRadius: 16,
            }}
          >
            <span
              style={{
                fontSize: 26,
                fontWeight: 500,
                color: "#1B6FBA",
              }}
            >
              {`Sebaran Data ${
                selectedAgama === "" ? "Semua Agama" : `Agama ${selectedAgama}`
              } di ${
                selectedProvince === ""
                  ? "Seluruh Provinsi"
                  : `Provinsi ${selectedProvince}`
              }`}
            </span>
          </Card>
        </Col>
        <Col span={12} className="text-header" style={{ padding: "0 8px" }}>
          Profil Lulusan
        </Col>
        <Col span={12} className="text-header" style={{ padding: "0 8px" }}>
          Guru/Dosen Tenaga Kependidikan
        </Col>
        <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.profilLulusan} />
        </Col>
        <Col span={12} style={{ padding: "0 8px" }}>
          <Row>
            <Col span={24} style={{ paddingBottom: "8px" }}>
              <ChartCard {...cards.chart.tendikGender} />
            </Col>
            <Col span={24} style={{ paddingBottom: "8px" }}>
              <ChartCard {...cards.chart.tendikLulusan} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout>
  );
};

export default Page;
